import * as actions from './index';
import { TOP_20, ALL_RECRUITS } from '../../util/constants';
import { getTop20List } from '../../util/StaffUtils';
import { getTop20Recruits } from './miscActions';
import _ from 'underscore';
import { generateActionCreators } from 'redux-crud-resources';
import { CRUDABLE_RESOURCES } from '../constants';

const CRUD_ACTION_CREATORS = generateActionCreators(CRUDABLE_RESOURCES, actions);

// list overrides
const getAllLists = (dao, params, model) => {
  const finalParams = { ...params, myLists: true };
  const promise = dao.lists.getAll(finalParams);

  const onSuccess = (dispatch, lists) => {
    if (lists.length === 0) {
      const commonParams = { accountId: model.getAccountId(), userId: model.getUserId() };
      // create private top 20 list for current user
      const params = {
        name: `${model.getUser().initials} ${TOP_20}`,
        type: 'FIXED',
        category: 'TOP_20',
        shared: false,
        ...commonParams
      };
      dispatch(CRUD_ACTION_CREATORS.saveList(dao, params));
      // create ALL list, locked
      dispatch(CRUD_ACTION_CREATORS.saveList(dao, {
        name: ALL_RECRUITS, type: 'SMART', category: 'ALL_RECRUITS', ...commonParams
      }));
    } else {
      dispatch({ type: actions.GET_ALL_LISTS_SUCCESS, lists, user: model.getUser() });
      dispatch(getTop20Recruits(dao, getTop20List(lists, model.getUser())));
    }
  };

  const onError = (dispatch, error) => {
    dispatch({ type: actions.GET_ALL_LISTS_ERROR, error });
  };

  return (dispatch) => {
    dispatch({ type: actions.GET_ALL_LISTS, promise, });

    return promise
      .then((lists) => onSuccess(dispatch, lists))
      .catch((error) => onError(dispatch, error));
  };
};


const saveList = (dao, list, fetchRecruits) => {
  const promise = dao.lists.save(list);

  const onSuccess = (dispatch, list, listRecruits) => dispatch({
    type: actions.SAVE_LIST_SUCCESS,
    list,
    listRecruits
  });

  const onError = (dispatch, error) => dispatch({
    type: actions.SAVE_LIST_ERROR,
    error,
  });

  return (dispatch) => {
    dispatch({ type: actions.SAVE_LIST, promise });
    return promise
      .then((list) => {
        if (list.category === 'TOP_20') {
          dispatch(getTop20Recruits(dao, list));
        }
        fetchRecruits ? dao.recruits.get({ listId: list.id, sort: [ 'A|lastName' ] })
          .then(({ results }) => {
            onSuccess(dispatch, list, results);
          }) : onSuccess(dispatch, list, null);
      })
      .catch((error) => onError(dispatch, error));
  };
};

// event overrides
const deleteEvent = (dao, event, accountId) => {
  const promise = dao.events.destroyId(event.id);

  const onSuccess = (dispatch) => {
    dispatch({
      type: actions.DELETE_EVENT_SUCCESS,
      event,
      onClickUndo: () => dispatch(saveEvent(dao, event, accountId))
    });
  };

  const onError = (dispatch, error) => {
    dispatch({ type: actions.DELETE_EVENT_ERROR, event, error, });
  };

  return (dispatch) => {
    dispatch({ type: actions.DELETE_EVENT, promise });

    return promise
      .then(() => onSuccess(dispatch))
      .catch((error) => onError(dispatch, error));
  };
};

const saveEvent = (dao, event, accountId) => {
  const promise = dao.events.save(event, accountId);

  const onSuccess = (dispatch, event) => {
    dispatch({ type: actions.SAVE_EVENT_SUCCESS, event });
  };

  const onError = (dispatch, error) => {
    dispatch({ type: actions.SAVE_EVENT_ERROR, event, error });
  };

  return (dispatch) => {
    dispatch({ type: actions.SAVE_EVENT, promise, });

    return promise
      .then((event) => onSuccess(dispatch, event))
      .catch((error) => onError(dispatch, error));
  };
};

const saveEvents = (dao, events, accountId) => {
  const promise = Promise.all(_.map(events, event => dao.events.save(event, accountId)));

  const onSuccess = (dispatch, event) => {
    dispatch({ type: actions.SAVE_EVENTS_SUCCESS, events });
  };

  const onError = (dispatch, error) => {
    dispatch({ type: actions.SAVE_EVENTS_ERROR, events, error });
  };

  return (dispatch) => {
    dispatch({ type: actions.SAVE_EVENTS, promise, });

    return promise
      .then((events) => onSuccess(dispatch, events))
      .catch((error) => onError(dispatch, error));
  };
};

// notes overrides
const deleteNote = (dao, note) => {
  const promise = dao.notes.save({ ...note, archived: true });

  const onSuccess = (dispatch, archivedNote) => {
    return dispatch({
      type: actions.DELETE_NOTE_SUCCESS,
      note,
      onClickUndo: () => dispatch(saveNote(dao, archivedNote))
    });
  };

  const onError = (dispatch, error) => {
    dispatch({ type: actions.DELETE_NOTE_ERROR, note, error, });
  };

  return (dispatch) => {
    dispatch({ type: actions.DELETE_NOTE, promise });

    return promise
      .then((note) => {
        onSuccess(dispatch, note);
        dispatch(CRUD_ACTION_CREATORS.getSingleRecruit(dao, note.recruit.id));
      })
      .catch((error) => onError(dispatch, error));
  };
};

const saveNote = (dao, note, top20List) => {
  const promise = dao.notes.save({ ...note, archived: false });

  const onSuccess = (dispatch, note) => {
    dispatch({ type: actions.SAVE_NOTE_SUCCESS, note });
  };

  const onError = (dispatch, error) => {
    dispatch({ type: actions.SAVE_NOTE_ERROR, note, error });
  };

  return (dispatch) => {
    dispatch({ type: actions.SAVE_NOTE, promise, });

    return promise
      .then((note) => {
        if (top20List) {
          dispatch(getTop20Recruits(dao, top20List));
        }
        onSuccess(dispatch, note);
        dispatch(CRUD_ACTION_CREATORS.getSingleRecruit(dao, note.recruit.id));
      })
      .catch((error) => onError(dispatch, error));
  };
};

// recruits overrides
const deleteRecruits = (dao, recruits) => {
  const promise = dao.recruits.destroyIds(_.pluck(recruits, 'id'));

  const onSuccess = (dispatch) => {
    _.map(recruits, (recruit) => dispatch({
      type: actions.DELETE_RECRUIT_SUCCESS,
      recruit,
      onClickUndo: () => dispatch(CRUD_ACTION_CREATORS.saveRecruit(dao, recruit))
    }));
  };

  const onError = (dispatch, error) => {
    dispatch({ type: actions.DELETE_RECRUITS_ERROR, error });
  };

  return (dispatch) => {
    dispatch({ type: actions.DELETE_RECRUIT, promise });

    return promise
      .then(() => onSuccess(dispatch))
      .catch((error) => onError(dispatch, error));
  };
};

// sessions
const getAllSessions = (dao, params) => {
  const promise = dao.sessions.getAll(params);

  const onSuccess = (dispatch, sessions) => {
    dispatch({ type: actions.GET_ALL_SESSIONS_SUCCESS, sessions });
  };

  const onError = (dispatch, error) => {
    dispatch({ type: actions.GET_ALL_SESSIONS_ERROR, error });
  };

  return (dispatch) => {
    dispatch({ type: actions.GET_ALL_SESSIONS, promise });

    return promise
      .then((sessions) => onSuccess(dispatch, sessions))
      .catch((error) => onError(dispatch, error));
  };
};

// recruits
const deleteAllRecruits = (dao, params) => {
  const promise = dao.recruits.destroyAll(params);

  const onSuccess = (dispatch) => dispatch({ type: actions.DELETE_ALL_RECRUITS_SUCCESS });
  const onError = (dispatch, error) => dispatch({ type: actions.DELETE_ALL_RECRUITS_ERROR, error });

  return (dispatch) => {
    dispatch({ type: actions.DELETE_ALL_RECRUITS, promise });

    return promise
      .then(() => {
        dispatch(CRUD_ACTION_CREATORS.getRecruits(dao, params));
        onSuccess(dispatch);
      })
      .catch((error) => onError(dispatch, error));
  };
};

const getNoRecruitEvents = (dao, params) => {
  const promise = dao.events.getAll(params);

  const onSuccess = (dispatch, events) => dispatch({ type: actions.GET_RECRUIT_APPOINTMENTS_SUCCESS, events });
  const onError = (dispatch, error) => dispatch({ type: actions.DELETE_ALL_RECRUITS_ERROR, error });

  return (dispatch) => {
    return promise
      .then((events) => dispatch(onSuccess(dispatch, events)))
      .catch((error) => onError(dispatch, error));
  };
};

const clearEvents = () => ({ type: actions.CLEAR_HOME_CALENDAR_EVENTS_SUCCESS });

module.exports = {
  ...CRUD_ACTION_CREATORS,
  getAllLists,
  saveList,
  deleteEvent,
  saveEvent,
  saveEvents,
  deleteNote,
  saveNote,
  deleteRecruits,
  getAllSessions,
  getNoRecruitEvents,
  deleteAllRecruits,
  clearEvents,
};



// WEBPACK FOOTER //
// ./src/js/FastRecruit/actions/actionCreators.js